import { useSelector } from 'react-redux';
import {
  getGroupChats,
  getGroupUnread,
  getMessages,
  getOnlineChange,
  getReceiver,
  getSelectedGroup,
  getUpdatedGroup,
  getUpdateGroupUnread,
  getUserUnread,
} from 'store/messages/index';

export const useMessages = () => useSelector(getMessages);

export const useSelectedGroup = () => useSelector(getSelectedGroup);

export const useReceiver = () => useSelector(getReceiver);

export const useGroupChats = () => useSelector(getGroupChats);

export const useOnlineChange = () => useSelector(getOnlineChange);

export const useGroupUnread = () => useSelector(getGroupUnread);

export const useUpdateUnread = () => useSelector(getUpdateGroupUnread);

export const useUserUnread = () => useSelector(getUserUnread);

export const useUpdatedGroup = () => useSelector(getUpdatedGroup);
